import { create } from 'zustand';
import { EtisStopDTO } from '@/api/trafikportalen';

const RECENT_STOPS_KEY = 'recentStops';
const MAX_RECENT_STOPS = 10;

interface RecentStop {
  id: string;
  name: string;
}

interface RecentStopsStore {
  recentStops: RecentStop[];
  addRecentStop: (stop: EtisStopDTO) => void;
}

export const useRecentStops = create<RecentStopsStore>((set) => ({
  recentStops: JSON.parse(localStorage.getItem(RECENT_STOPS_KEY) || '[]'),
  addRecentStop: (stop: EtisStopDTO) => {
    set((state) => {
      const newStop = { id: String(stop.id), name: stop.name };
      const filteredStops = state.recentStops.filter(
        (s) => s.id !== newStop.id,
      );
      const updatedStops = [newStop, ...filteredStops].slice(
        0,
        MAX_RECENT_STOPS,
      );
      localStorage.setItem(RECENT_STOPS_KEY, JSON.stringify(updatedStops));
      return { recentStops: updatedStops };
    });
  },
}));
